<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12">
				<v-tabs>
					<v-tab>{{ $t('tabs.courses') }}</v-tab>
					<v-tab>{{ $t('tabs.candidates') }}</v-tab>
					<v-tab>{{ $t('tabs.partners') }}</v-tab>
					<v-tab>{{ $t('tabs.attendedCourses') }}</v-tab>
					<v-tab>{{ $t('tabs.costs') }}</v-tab>

					<v-tab-item>
						<Courses></Courses>
					</v-tab-item>
					<v-tab-item>
						<Candidates></Candidates>
					</v-tab-item>
					<v-tab-item>
						<Partners></Partners>
					</v-tab-item>
					<v-tab-item>
						<AttendedCourses></AttendedCourses>
					</v-tab-item>
					<v-tab-item>
						<Costs></Costs>
					</v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Candidates from './Candidates';
import Partners from './Partners';
import AttendedCourses from './AttendedCourses';
import Courses from './Courses';
import Costs from './Costs';

export default {
	name: 'Stats',
	components: {
		Candidates,
		AttendedCourses,
		Partners,
		Courses,
		Costs,
	},
	data: function () {
		return {};
	},
	methods: {},

	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		if (this.$myStore.state.user.user_role_id == 2) {
			this.$router.replace('/candidates');
		}
		let vm = this;

		this.$myStore.commit('setBreadcrumbs', [
			{
				text: vm.$t('modules.stats'),
				href: '/#/stats',
				disabled: false,
			},
		]);
	},
};
</script>

<style scoped></style>
